import { gql } from 'graphql-request'

export const GetWelcomeMessageGql = gql`
  query welcomeMessage {
    welcomeMessage
  }
`
